import { AcceptAllConsent } from 'src/ConsentManagement/ConsentStorage';
import { ConsentEventType } from 'src/Shared/EventPublisher/ConsentEventType';
import { Publish } from 'src/Shared/EventPublisher/EventEmitter';
import { Button } from './Button';
import { UseVendorSelections } from './UiStates/UseVendorSelections';

export const AcceptAllButton = ({ id }: { id: string }) => {
  const { vendorSelections, setVendorSelections } = UseVendorSelections();
  const AcceptAllHandler = () => {
    const newSelections = vendorSelections.OptAllIn();
    setVendorSelections(newSelections.models);
    AcceptAllConsent();
    Publish(ConsentEventType.REQUEST_CLOSE_CONSENT_UI);
  };

  return (
    <Button id={id} class="primary-button ccmgt_accept_button" onClick={AcceptAllHandler} translationKey="accept_all" />
  );
};
